import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface Option {
  label: string;
  value: string;
}

interface SelectFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (val: string) => void;
  options: Option[];
  error?: string;
  mandatory?: boolean;
}

export default function SelectField({
  name,
  label,
  placeholder,
  value,
  onChange,
  options,
  error,
  mandatory,
}: SelectFieldProps) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className="text-14 font-medium mt-0 text-gray-900"
        >
          {label}
          {mandatory && <span className="text-red-500">*</span>}
        </label>
      )}

      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          id={name}
          name={name}
          className={cn(
            "w-full border font-medium border-slate-300 rounded-[8px] px-3 py-2 text-xs text-slate-800 bg-white transition-colors cursor-pointer",
            "focus:border-[var(--brand-accent)] focus:ring-1 focus:ring-[var(--brand-accent)] outline-none",
            error && "border-red-500"
          )}
        >
          <SelectValue placeholder={placeholder || "Select option"} />
        </SelectTrigger>

        <SelectContent className="z-50 bg-white border border-slate-200 rounded-[8px] shadow-lg">
          {options.map((opt) => (
            <SelectItem 
              key={opt.value} 
              value={opt.value} 
              className="text-xs font-semibold cursor-pointer hover:bg-[var(--brand-accent)]/10 hover:text-[var(--brand-accent)] focus:bg-[var(--brand-accent)]/10 focus:text-[var(--brand-accent)] data-[state=checked]:text-[var(--brand-accent)] data-[state=checked]:font-bold"
            >
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span className="text-xs text-red-500 min-h-[16px]">
        {" "}
        {error && <p className="text-xs text-red-500">{error}</p>}
      </span>
    </div>
  );
}
